import e from "./TooltipBind_vue.js";
//#region src/components/ui/tooltip/wrapper/TooltipBind.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=TooltipBind.js.map